import { render, staticRenderFns } from "./Navigator.vue?vue&type=template&id=53230092&scoped=true&"
import script from "./Navigator.vue?vue&type=script&lang=js&"
export * from "./Navigator.vue?vue&type=script&lang=js&"
import style0 from "./Navigator.vue?vue&type=style&index=0&id=53230092&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53230092",
  null
  
)

component.options.__file = "Navigator.vue"
export default component.exports